var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMenuList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\x93\xB1 \xED\x9C\xB4\xEB\x8C\x80\xEC\xA0\x84\xED\x99\x94"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.73437 13H5.21397C3.75608 13 2.57422 14.1819 2.57422 15.6398V19.1602C2.57422 20.618 3.75608 21.7999 5.21397 21.7999H8.73437C10.1923 21.7999 11.3741 20.618 11.3741 19.1602V15.6398C11.3741 14.1819 10.1923 13 8.73437 13Z",
    fill: "#DBDCDF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.5337 2.2002H16.0134C14.5555 2.2002 13.3737 3.38204 13.3737 4.83992V8.36028C13.3737 9.81815 14.5555 11 16.0134 11H19.5337C20.9916 11 22.1735 9.81815 22.1735 8.36028V4.83992C22.1735 3.38204 20.9916 2.2002 19.5337 2.2002Z",
    fill: "#DBDCDF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.7343 2.2002H5.21394C3.75606 2.2002 2.57422 3.38204 2.57422 4.83992V8.36028C2.57422 9.81815 3.75606 11 5.21394 11H8.7343C10.1922 11 11.374 9.81815 11.374 8.36028V4.83992C11.374 3.38204 10.1922 2.2002 8.7343 2.2002Z",
    fill: "#DBDCDF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16.0157 21.7998H19.5361C20.9939 21.7998 22.1758 20.618 22.1758 19.1601V15.6397C22.1758 14.1818 20.9939 13 19.5361 13H16.0157C14.5578 13 13.376 14.1818 13.376 15.6397V19.1601C13.376 20.618 14.5578 21.7998 16.0157 21.7998Z",
    fill: "#DBDCDF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuList);
export default __webpack_public_path__ + "static/media/icon_menu_list.092a10b556968ddf1547d329a2702723.svg";
export { ForwardRef as ReactComponent };